export default __webpack_public_path__ + "static/media/puma-K.850673a3.png";